import { useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'

import { concatParams, getHashFromUrl, getParams } from 'utils/getURLData'
import { formatSelectForURL, formatDateForURL } from './utils'
import { IOptions, IStringObj } from 'constants/types/common.types'
import { IParams, IOptionAliases } from 'constants/types/search.types'
import { multiSelectKeys, Key } from 'constants/search-data/search-data'

const useSyncURL = (
  selectedOption: string,
  OptionAliases: IOptionAliases,
  params?: IParams,
  noType?: boolean
): void => {
  const router = useRouter()
  const queryParams = useMemo(() => getParams(router.asPath), [])
  const { origin } = queryParams

  useEffect(() => {
    let filteredParams: IStringObj = {}
    if (params) {
      const currentParams = params[selectedOption]

      filteredParams = Object.keys(currentParams).reduce((acc, key) => {
        let param

        if (multiSelectKeys.includes(key) && currentParams[key]?.length)
          param = formatSelectForURL(currentParams[key] as IOptions[])
        else if (key === Key.DATES && currentParams[key]?.length) {
          const dates = formatDateForURL(currentParams[key] as Date[])
          param = dates.length ? dates : ''
        } else if (key === Key.PAGE && currentParams[key]) {
          const pageNumber = Number(currentParams[key])
          param = pageNumber > 1 ? String(pageNumber) : undefined
        } else if (currentParams[key]?.length) param = currentParams[key]

        return param ? { ...acc, [key]: param } : acc
      }, {})
    }

    const initHash = getHashFromUrl(router.asPath)
    const aliasIndex = OptionAliases.findIndex((option) => option.option === selectedOption)
    const alias = OptionAliases[aliasIndex]
    const query =
      concatParams({
        ...filteredParams,
        type: noType || aliasIndex === 0 ? undefined : alias?.alias,
        origin: origin,
        speciality: router.query?.speciality,
      }) + initHash

    router.replace(`${router.pathname}${query ? '?' + query : ''}`, undefined, { shallow: true })
  }, [selectedOption, params?.[selectedOption]])
}

export default useSyncURL
